@if (searchBarType === 'search') {
  <div class="flex align-end flex-wrap full-width"
    style="gap: 0.5rem"
    >
    <div class="flex flex-1 search-container"
      [ngClass]="{'justify-content-end' : settings.removeSearchBar === true}">
      @if (!settings.removeSearchBar) {
        <div class="flex-1 flex align-end "
          >
          <div class="flex-1 margin-right-small search-bar">
            <!-- <label [for]="settings.inputId">Search</label> -->
            <input class="form-control min-h bg-white"
              [id]="settings.inputId"
              [placeholder]="settings.placeholder | translate"
              [(ngModel)]="internalSearch"
              [ngModelOptions]="{standalone: true}"
              (blur)="onBlurSearch()"
              (keydown.enter)="onSearch()" />
              @if (internalSearch) {
                <div
                  class="pointer"
                  (click)="onClearSearch()">
                  <span data-feather="x"></span>
                </div>
              }
            </div>
            <button rippleEffect
              class="btn btn-primary"
              (click)="onSearch()">
              <span data-feather="search"></span>
            </button>
          </div>
        }
        @if (settings.showFilters) {
          <button
            class="btn btn-flat-primary margin-left-small "
            rippleEffect
            (click)="onToggleFilters()">
             {{'GENERIC_LABEL.FILTER' | translate}}
            <span data-feather="filter"></span>
          </button>
        }
        @if (settings.showUploadButton && canUploadFiles) {
          <button
            class="btn btn-primary margin-left-small  min-h "
            (click)="onUploadFile()">
            <span data-feather="upload"></span>
            <span>{{ "TABLE.ACTION.UPLOAD" | translate }}</span>
          </button>
        }
        @if (settings.actionList?.length === 1) {
          <div
            [ngbTooltip]="settings.actionList[0].tooltip | translate"
            class="margin-left-small">
            <button class="btn btn-outline-primary "
              [disabled]="settings.actionList[0].disabled"
              (click)="
          onAction(
            settings.actionList[0].id?.toString()
              ? settings.actionList[0].id
              : settings.actionList[0].name
          )
        ">
              <span [data-feather]="settings.actionList[0].icon"></span>
              <span>{{ settings.actionList[0].name | translate }}</span>
            </button>
          </div>
        }
        @if (settings.actionList?.length > 1) {
          <div
            class="btn-filter margin-left-small">
            <div ngbDropdown
              placement="bottom-right">
              <button ngbDropdownToggle
                class="btn btn-outline-primary nav-hide-arrow"
                id="dropdownMenuButton">
                <span data-feather="more-vertical"></span>
                <span>{{ "TABLE.ACTION.NAME" | translate }}</span>
              </button>
              <div ngbDropdownMenu
                aria-labelledby="dropdownMenuButton">
                @for (item of settings.actionList; track item) {
                  <a ngbDropdownItem
                    [disabled]="item.disabled"
                    (click)="onAction(item.id?.toString() ? item.id : item.name)">
                    @if (item.icon !== '') {
                      <span
                        class="mr-25"
                      [data-feather]="item.icon"></span>
                    }
                    <span>{{ item.name | translate }}</span>
                  </a>
                }
              </div>
            </div>
          </div>
        }
      </div>
      @if (customActionsTemplate) {
        <div
          class="flex">
          <ng-content *ngTemplateOutlet="customActionsTemplate"></ng-content>
        </div>
      }
    </div>
  }

  @if (searchBarType === 'filter' && currentFilters?.length) {
    <div class="flex align-end flex-wrap full-width"
      >
      @for (filter of currentFilters; track filter; let i = $index; let first = $first; let last = $last) {
        <div class="btn-group"
          >
          @if (!filter.isDisable) {
            <div ngbDropdown
              [placement]="last ? ['bottom-right','top-right','bottom-left','top-left'] : first ? ['bottom-left','top-left'] : ['bottom','top']"
              (openChange)="filter.opened = $event">
              <button ngbDropdownToggle
                [disabled]="filter.isDisablePanel || filter.isDropDownAndChips"
                class="btn btn-flat-secondary dropdown-menu-custom padding-left-small padding-right-small"
                type="button"
                id="dropdownMenuButton"
                rippleEffect>
                {{filter.name | translate}}
              </button>
              <div ngbDropdownMenu
                class="padding-left-small padding-right-small"
                aria-labelledby="dropdownMenuButton">
                <ng-container *ngTemplateOutlet="FiltersList; context: { $implicit: filter }"></ng-container>
                <div class="dropdown-divider"></div>
                <button type="button"
                  (click)="onApplyFilters()"
                class="btn btn-primary w-100">Apply</button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (showFiltersChips) {
    <div
      class="flex align-center flex-wrap margin-top-small"
      style="gap: 5px">
      <span>{{ "TABLE.FILTERS.ACTIVE_FILTERS" | translate }}:</span>
      @for (filter of currentFilters; track filter) {
        @switch (filter.type) {
          @case (filterTypeEnum.date) {
            @if (!filter.isRange) {
              @for (item of filter.data; track item) {
                @if (!!item.value) {
                  <div
                    class="badge badge-pill badge-primary flex align-center">
                    <span class="capitalize-first-world">{{ item.text | translate }}|
                    {{ item.value | date: "d MMM y" }}</span>
                    @if (!filter.isDropDownAndChips) {
                      <span class="pointer margin-left-small"
                        (click)="onRemoveFilter(filter, item)">
                        <span data-feather="x"></span>
                      </span>
                    }
                  </div>
                }
              }
            }
            @if (filter.isRange) {
              @if (filter.data | checkRange) {
                <div
                  class="badge badge-pill badge-primary flex align-center">
                  <span class="capitalize-first-world">{{ filter.name | translate }}|</span>
                  @for (item of filter.data; track item) {
                    @if (item.value) {
                      <span
                        class="ml-space-03">{{ item.text | translate }}:
                      {{ item.value | date: "d MMM y" }}</span>
                    }
                  }
                  @if (!filter.isDropDownAndChips) {
                    <span class="pointer margin-left-small"
                      (click)="onRemoveFilter(filter)">
                      <span data-feather="x"></span>
                    </span>
                  }
                </div>
              }
            }
          }
          @case (filterTypeEnum.priceFilter) {
            @if (!filter.isRange) {
              @for (item of filter.data; track item) {
                @if (!!item.value) {
                  <div
                    class="badge badge-pill badge-primary flex align-center">
                    <span class="capitalize-first-world">{{ item.text === "" ? filter.name : (item.text | translate) }}:
                    {{ item.value | currency: "EUR" }}</span>
                    @if (!filter.isDropDownAndChips) {
                      <span class="pointer margin-left-small"
                        (click)="onRemoveFilter(filter, item)">
                        <span data-feather="x"></span>
                      </span>
                    }
                  </div>
                }
              }
            }
            @if (filter.isRange) {
              @if (filter.data | checkRange) {
                <div
                  class="badge badge-pill badge-primary flex align-center">
                  <span class="capitalize-first-world">{{ filter.name | translate }}|</span>
                  @for (item of filter.data; track item) {
                    @if (item.value) {
                      <span
                        class="ml-space-03">{{ item.text | translate }}:
                      {{ item.value | currency: "EUR" }}</span>
                    }
                  }
                  @if (!filter.isDropDownAndChips) {
                    <span class="pointer margin-left-small"
                      (click)="onRemoveFilter(filter)">
                      <span data-feather="x"></span>
                    </span>
                  }
                </div>
              }
            }
          }
          @case (filterTypeEnum.amountFilter) {
            @if (!filter.isRange) {
              @for (item of filter.data; track item) {
                <div>
                  @if (!!item.value) {
                    <div
                      class="badge badge-pill badge-primary flex align-center">
                      <span class="capitalize-first-world">{{ item.text === "" ? filter.name : (item.text | translate) }}:
                      {{ item.value | number }}</span>
                      @if (!filter.isDropDownAndChips) {
                        <span class="pointer margin-left-small"
                          (click)="onRemoveFilter(filter, item)">
                          <span data-feather="x"></span>
                        </span>
                      }
                    </div>
                  }
                </div>
              }
            }
            @if (filter.isRange) {
              @if (filter.data | checkRange) {
                <div
                  class="badge badge-pill badge-primary flex align-center">
                  <span class="capitalize-first-world">{{ filter.name | translate }}|</span>
                  @for (item of filter.data; track item) {
                    @if (item.value) {
                      <span
                      class="ml-space-03">{{ item.text | translate }}: {{ item.value | number }}</span>
                    }
                  }
                  @if (!filter.isDropDownAndChips) {
                    <span class="pointer margin-left-small"
                      (click)="onRemoveFilter(filter)">
                      <span data-feather="x"></span>
                    </span>
                  }
                </div>
              }
            }
          }
          @case (filterTypeEnum.inputFilter) {
            @for (item of filter.data; track item) {
              <div>
                @if (!!item.value) {
                  <div
                    class="badge badge-pill badge-primary flex align-center">
                    <span class="capitalize-first-world">{{ item.text === "" ? filter.name : (item.text | translate) }}:
                    {{ item.value }}</span>
                    @if (!filter.isDropDownAndChips) {
                      <span class="pointer margin-left-small"
                        (click)="onRemoveFilter(filter, item)">
                        <span data-feather="x"></span>
                      </span>
                    }
                  </div>
                }
              </div>
            }
          }
          @default {
            @for (item of filter.selected; track item) {
              @if (!!item?.value?.toString()) {
                <div
                  class="badge badge-pill badge-primary flex align-center">
                  <span style="max-width: 150px; cursor: default"
                    class="truncate"
                    [ngbTooltip]="item.text | translate">
                    <span class="capitalize-first-world">{{ filter.name | translate }} |
                    {{ item.text | translate }}</span>
                  </span>
                  @if (!filter.isDropDownAndChips) {
                    <span class="pointer margin-left-small"
                      (click)="onRemoveFilter(filter, item)">
                      <span data-feather="x"></span>
                    </span>
                  }
                </div>
              }
            }
          }
        }
      }
    </div>
  }

  @if (showFilters) {
    <app-sidebar
      [show]="showFilters"
      [actionButtons]="sidebarActionButtons"
      [title]="'TABLE.FILTERS.FILTERS'"
      (close)="onToggleFilters()"
      (clickButton)="onApplyFilters()">
      <div class="flex-1 flex center"
        style="padding: 2px">
        @if (currentFilters?.length) {
          <div ngbAccordion
            #filterAccordion="ngbAccordion"
            [destroyOnHide]="false">
            @for (filter of currentFilters; track filter; let i = $index) {
              @if (!filter.isDisable) {
                <div
                  [ngbAccordionItem]="filter.panelId"
                  [disabled]="filter.isDisablePanel"
                  (hidden)="filter.opened = false"
                  (shown)="filter.opened = true">
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>
                      <div style="flex: 1;"
                        class="collapse-title flex align-center">
                        <div class="flex-1 flex align-center flex-wrap truncate">
                          <div class="flex-1 truncate padding-right-large">
                            <div class="capitalize-first-world text-left truncate">
                              {{ filter.name | translate }}
                            </div>
                          </div>
                          <div style="max-width: 150px"
                            class="lead margin-right truncate">
                            {{ filter.description | translate }}
                          </div>
                        </div>
                      </div>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <ng-container *ngTemplateOutlet="FiltersList; context: { $implicit: filter }"></ng-container>
                      </ng-template>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>
    </app-sidebar>
  }




  <ng-template #FiltersList
    let-filter>
    @if (filter.type === filterTypeEnum.date) {
      <app-generic-date [filter]="filter"></app-generic-date>
    }

    @if (filter.type === filterTypeEnum.radio) {
      <app-generic-radio [filter]="filter"></app-generic-radio>
    }

    @if (filter.type === filterTypeEnum.agencyFilter) {
      <app-agency-filter [filter]="filter"
      [accordionState]="filter.opened"></app-agency-filter>
    }

    @if (filter.type === filterTypeEnum.tierFilter) {
      <app-tier-filter [filter]="filter"
      [accordionState]="filter.opened"></app-tier-filter>
    }

    @if (filter.type === filterTypeEnum.onlineStoreFilter) {
      <app-online-store-filter [filter]="filter"></app-online-store-filter>
    }

    @if (filter.type === filterTypeEnum.cityFilter) {
      <app-city-filter [filter]="filter"
      [accordionState]="filter.opened"></app-city-filter>
    }

    @if (filter.type === filterTypeEnum.customerFilter) {
      <app-customer-filter [filter]="filter"
      [accordionState]="filter.opened"></app-customer-filter>
    }

    @if (filter.type === filterTypeEnum.ordersFilter) {
      <app-order-filter [filter]="filter"
      [accordionState]="filter.opened"></app-order-filter>
    }

    @if (filter.type === filterTypeEnum.seasonReferenceFilter) {
      <app-season-reference-filter [filter]="filter"
      [accordionState]="filter.opened"></app-season-reference-filter>
    }

    @if (filter.type === filterTypeEnum.byCustomizationRequest) {
      <app-customization-requests-filter [filter]="filter"
      [accordionState]="filter.opened"></app-customization-requests-filter>
    }

    @if (filter.type === filterTypeEnum.showcasesFilter) {
      <app-showcases-filter [filter]="filter"
      [accordionState]="filter.opened"></app-showcases-filter>
    }

    @if (filter.type === filterTypeEnum.voucherFilter) {
      <app-voucher-filter [filter]="filter"
      [accordionState]="filter.opened"></app-voucher-filter>
    }

    @if (filter.type === filterTypeEnum.posFilter) {
      <app-pos-filter [filter]="filter"
      [accordionState]="filter.opened"></app-pos-filter>
    }

    @if (filter.type === filterTypeEnum.priceFilter) {
      <app-price-filter [filter]="filter"></app-price-filter>
    }

    @if (filter.type === filterTypeEnum.amountFilter) {
      <app-amount-filter [filter]="filter"></app-amount-filter>
    }

    @if (filter.type === filterTypeEnum.roleFilter) {
      <app-role-filter [filter]="filter"
      [accordionState]="filter.opened"></app-role-filter>
    }

    @if (filter.type === filterTypeEnum.checkbox) {
      <app-generic-check-box [filter]="filter"></app-generic-check-box>
    }

    @if (filter.type === filterTypeEnum.assortmentFilter) {
      <app-assortment-filter [filter]="filter"
      [accordionState]="filter.opened"></app-assortment-filter>
    }

    @if (filter.type === filterTypeEnum.variantSize) {
      <app-variant-size [filter]="filter"
      [accordionState]="filter.opened"></app-variant-size>
    }

    @if (filter.type === filterTypeEnum.paletteFilter) {
      <app-palette-filter [filter]="filter"
      [accordionState]="filter.opened"></app-palette-filter>
    }

    @if (filter.type === filterTypeEnum.basicCollectionFilter) {
      <app-basic-collection-filter [filter]="filter"
        [accordionState]="filter.opened"
        [use4shopId]="filter.use4shopId">
      </app-basic-collection-filter>
    }

    @if (filter.type === filterTypeEnum.inputFilter) {
      <app-generic-input-filter [filter]="filter"></app-generic-input-filter>
    }

    @if (filter.type === filterTypeEnum.styleGroupFilter) {
      <app-style-group-filter [filter]="filter"
      [accordionState]="filter.opened"></app-style-group-filter>
    }

    @if (filter.type === filterTypeEnum.channelFilter) {
      <app-channel-filter [filter]="filter"></app-channel-filter>
    }

    @if (filter.type === filterTypeEnum.productFilter) {
      <app-products-filter [filter]="filter"
      [accordionState]="filter.opened"></app-products-filter>
    }
    @if (filter.type === filterTypeEnum.userFilter) {
      <app-user-filter [filter]="filter"
      [accordionState]="filter.opened"></app-user-filter>
    }

    @if (filter.type === filterTypeEnum.customerGroupCodeFilter) {
      <app-customer-group-code-filter [filter]="filter"
      [accordionState]="filter.opened"></app-customer-group-code-filter>
    }

    @if (filter.type === filterTypeEnum.customerSubgroupCodeFilter) {
      <app-customer-subgroup-code-filter [filter]="filter"
      [accordionState]="filter.opened"></app-customer-subgroup-code-filter>
    }

    @if (filter.type === filterTypeEnum.customerSignBoardFilter) {
      <app-customer-signboard-filter [filter]="filter"
      [accordionState]="filter.opened"></app-customer-signboard-filter>
    }

    @if (filter.type === filterTypeEnum.customerHoldingFilter) {
      <app-customer-holding-filter [filter]="filter"
      [accordionState]="filter.opened"></app-customer-holding-filter>
    }

    @if (filter.type === filterTypeEnum.customerGroupFilter) {
      <app-customer-group-filter [filter]="filter"
      [accordionState]="filter.opened"></app-customer-group-filter>
    }

    @if (filter.type === filterTypeEnum.salesTaxGroupFilter) {
      <app-sales-tax-group-filter [filter]="filter"
      [accordionState]="filter.opened"></app-sales-tax-group-filter>
    }
  </ng-template>
